import { Amount } from '@qvs/core';

export class AmountHelper {
  public static calculateAmount(amountOrNumber: Amount | number | string): Amount {
    const amount =
      typeof amountOrNumber === 'number' || typeof amountOrNumber === 'string'
        ? {
            currency: null,
            value: typeof amountOrNumber !== 'number' ? parseFloat(amountOrNumber) : amountOrNumber
          }
        : amountOrNumber;

    if (
      amountOrNumber &&
      typeof amountOrNumber !== 'number' &&
      typeof amountOrNumber !== 'string' &&
      typeof amountOrNumber.value === 'string'
    ) {
      amount.value = parseFloat(amountOrNumber.value);
    }
    return amount;
  }

  public static toString(
    amountOrNumber?: Amount | number | string,
    showCurrency?: boolean,
    showNullDecimals = true,
    minusAmount?: number,
    showAsNegative?: boolean,
    decimalCount?: number
  ): string {
    let amount = AmountHelper.calculateAmount(amountOrNumber);

    if (
      amount === undefined ||
      amount === null ||
      amount.value === undefined ||
      isNaN(amount.value) ||
      (typeof amount !== 'object' && isNaN(amount))
    ) {
      return '-';
    }
    let value = '';
    if (showCurrency && amount.currency) {
      value += `${amount.currency} `;
    }
    const decimals = decimalCount === undefined ? 2 : decimalCount;
    const fractionDigits = Number.isInteger(amount.value as any) ? (showNullDecimals ? decimals : 0) : decimals;

    if (minusAmount) {
      amount = { ...amount, value: parseFloat(amount.value as any) - minusAmount };
    }

    if (showAsNegative && amount.value > 0) {
      value += '-';
    }

    value += `${amount.value
      .toLocaleString('en-US', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      })
      .replace(/,/g, "'")}`;
    return value;
  }
}
